(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("kt3tw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "PiP", function () { return $ee69362773356d56$export$7e4ea342e3b07331; });
$parcel$export(module.exports, "MediaPiP", function () { return $ee69362773356d56$export$3dd460700b3588aa; });
$parcel$export(module.exports, "ProductsPiP", function () { return $ee69362773356d56$export$e150d92970e5308f; });
$parcel$export(module.exports, "ProductPiP", function () { return $ee69362773356d56$export$3da1fcaa27fa485e; });
$parcel$export(module.exports, "CategoryPiP", function () { return $ee69362773356d56$export$21a5ad6fe88e8a2f; });
$parcel$export(module.exports, "make", function () { return $ee69362773356d56$export$dd44f18ab656f3bb; });
$parcel$export(module.exports, "$$default", function () { return $ee69362773356d56$export$aa541d093b11ace2; });
$parcel$export(module.exports, "default", function () { return $ee69362773356d56$export$aa541d093b11ace2; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $b5sXm = parcelRequire("b5sXm");

var $c6E1z = parcelRequire("c6E1z");

var $7KlbQ = parcelRequire("7KlbQ");

var $7wIsS = parcelRequire("7wIsS");

var $1xf0g = parcelRequire("1xf0g");

var $55MCT = parcelRequire("55MCT");

var $gS5nW = parcelRequire("gS5nW");

var $ePRCc = parcelRequire("ePRCc");

var $gSQ4v = parcelRequire("gSQ4v");

var $gpCTg = parcelRequire("gpCTg");

var $1t9ha = parcelRequire("1t9ha");

var $1lWE3 = parcelRequire("1lWE3");

var $hBcYV = parcelRequire("hBcYV");

var $jBcRb = parcelRequire("jBcRb");

var $aSJcu = parcelRequire("aSJcu");

var $1xMeg = parcelRequire("1xMeg");

var $cdK26 = parcelRequire("cdK26");

var $9pMGg = parcelRequire("9pMGg");

var $kJLmR = parcelRequire("kJLmR");

var $8E2YL = parcelRequire("8E2YL");

var $gtaS4 = parcelRequire("gtaS4");

var $hm3Un = parcelRequire("hm3Un");
function $ee69362773356d56$var$PictureInPicture2$PiP(Props) {
    var mediaId = Props.mediaId;
    var zIndex = Props.zIndex;
    var width = Props.width;
    var height = Props.height;
    var isPausedOpt = Props.isPaused;
    var interactiveOpt = Props.interactive;
    var handleClose = Props.handleClose;
    var render = Props.render;
    var renderHover = Props.renderHover;
    var renderOverlay = Props.renderOverlay;
    var maxSize = Props.maxSize;
    var positionOpt = Props.position;
    var isPaused = isPausedOpt !== undefined ? isPausedOpt : false;
    var interactive = interactiveOpt !== undefined ? interactiveOpt : true;
    var position = positionOpt !== undefined ? positionOpt : "left";
    $8E2YL.use(undefined);
    var match = $aSJcu.use(undefined);
    var isMobile = match.isMobile;
    var ratio = width / height;
    var maxSize$1 = $2whNH.getWithDefault(maxSize, isMobile ? 150 : 300);
    var match$1 = ratio > 1 ? [
        maxSize$1,
        maxSize$1 / ratio
    ] : [
        maxSize$1 * ratio,
        maxSize$1
    ];
    var height$1 = match$1[1];
    var width$1 = match$1[0];
    var match$2 = $g85JO.useState(function() {
        return false;
    });
    var setHover = match$2[1];
    var hover = match$2[0];
    var handleMouseEnter = function handleMouseEnter(param) {
        $iv6Yc._1(setHover, function(param) {
            return true;
        });
    };
    var handleMouseLeave = function handleMouseLeave(param) {
        $iv6Yc._1(setHover, function(param) {
            return false;
        });
    };
    $g85JO.useEffect(function() {
        $iv6Yc._1(setHover, function(param) {
            return false;
        });
    }, [
        mediaId
    ]);
    var renderHover$1 = $2whNH.getWithDefault(renderHover, function(param) {
        return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($jBcRb.make, {
            className: $ezf3v.prefix("absolute inset-1/2 w-9 h-9 text-white z-20 transform -translate-x-1/2 -translate-y-1/2"),
            onClick: function onClick(param) {
                $iv6Yc._1(handleClose, undefined);
            },
            children: /*#__PURE__*/ $g85JO.createElement($gSQ4v.make, {
                className: $ezf3v.prefix("w-8 h-8")
            }),
            block: false,
            flex: true
        }), /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("absolute inset-0 bg-gray-700 opacity-40 z-10"),
            onClick: function onClick(param) {
                $iv6Yc._1(handleClose, undefined);
            }
        }));
    });
    var renderOverlay$1 = $2whNH.getWithDefault(renderOverlay, function(param) {
        return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("absolute inset-0 z-0"),
            onClick: function onClick(param) {
                if (isMobile) return $iv6Yc._1(handleClose, undefined);
                else return $iv6Yc._1(setHover, function(value) {
                    return !value;
                });
            }
        });
    });
    return /*#__PURE__*/ $g85JO.createElement($ePRCc.make, {
        initiator: "pip",
        portal: true,
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "fixed bottom-2 cursor-pointer",
                position === "right" ? "right-12" : "left-2",
                interactive ? "" : "pointer-events-none"
            ])),
            id: "maker-smartnav-pip",
            style: {
                height: "" + String(height$1) + "px",
                width: "" + String(width$1) + "px",
                zIndex: String($2whNH.mapWithDefault(zIndex, 10000000, $ezf3v.safeIncrementZIndex))
            },
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave
        }, $iv6Yc._3(render, width$1, height$1, hover), hover || isPaused ? $iv6Yc._1(renderHover$1, undefined) : null, $iv6Yc._1(renderOverlay$1, undefined))
    });
}
$ee69362773356d56$var$PictureInPicture2$PiP.displayName = "PictureInPicture2.PiP";
var $ee69362773356d56$export$7e4ea342e3b07331 = {
    make: $ee69362773356d56$var$PictureInPicture2$PiP
};
function $ee69362773356d56$var$PictureInPicture2$MediaPiP(Props) {
    var zIndex = Props.zIndex;
    var match = $gtaS4.use(undefined);
    var setMuted = match.setMuted;
    var saveTime = match.saveTime;
    var setMediaId = match.setMediaId;
    var muted = match.muted;
    var time = match.time;
    var backLocation = match.backLocation;
    var mediaId = match.mediaId;
    var config = $1xMeg.useQuickViewConfig(backLocation, undefined);
    var media = $i7mYY.getBy(config.media, function(m) {
        return $7bjme.equal(m.id, mediaId);
    });
    var match$1 = $kJLmR.use(true, media, undefined, undefined, undefined);
    var setProgressRef = match$1[2];
    var setProgress = match$1[1];
    var progressSpeed = match$1[0];
    var curIndex = mediaId !== undefined ? $2whNH.getWithDefault($i7mYY.getIndexBy(config.media, function(m) {
        return m.id === mediaId;
    }), 0) : 0;
    var goToSlide = function goToSlide(index) {
        $iv6Yc._1(setProgress, 0);
        if (setMediaId !== undefined) return $iv6Yc._5(setMediaId, backLocation, undefined, undefined, muted, $2whNH.map($i7mYY.get(config.media, index), function(media) {
            return media.id;
        }));
    };
    var next = function next(param) {
        var nextIndex = curIndex + 1 | 0;
        goToSlide(nextIndex < config.media.length ? nextIndex : 0);
    };
    var autoplayTimerRef = $g85JO.useRef(undefined);
    $g85JO.useEffect(function() {
        var $$clearTimeout$1 = function $$clearTimeout$1(param) {
            var id = autoplayTimerRef.current;
            if (id !== undefined) {
                clearTimeout($loT9g.valFromOption(id));
                return;
            }
        };
        $$clearTimeout$1(undefined);
        var kind = $2whNH.map(media, function(m) {
            return m.kind;
        });
        if (kind === "image") autoplayTimerRef.current = $loT9g.some(setTimeout(next, 5000));
        return function(param) {
            $$clearTimeout$1(undefined);
        };
    }, [
        $2whNH.mapWithDefault(media, "", function(m) {
            return m.id;
        })
    ]);
    var currentTime = $g85JO.useRef(0);
    var handleClose = function handleClose(param) {
        if (setMediaId !== undefined) return $iv6Yc._5(setMediaId, backLocation, currentTime.current, undefined, undefined, undefined);
    };
    var handleTimeChange = function handleTimeChange(time, duration) {
        currentTime.current = time;
        var progress = Math.round(time / duration * 100) | 0;
        $iv6Yc._1(setProgress, progress);
        if (saveTime !== undefined) return $iv6Yc._1(saveTime, time);
    };
    var match$2 = $g85JO.useState(function() {
        return false;
    });
    var setIsPaused = match$2[1];
    var isPaused = match$2[0];
    $g85JO.useEffect(function() {
        $iv6Yc._1(setIsPaused, function(param) {
            return false;
        });
    }, [
        mediaId
    ]);
    var noop = function noop(param) {};
    var noopReact = function noopReact(param) {
        return null;
    };
    if (media === undefined) return null;
    var tmp = {
        mediaId: mediaId,
        width: media.originalWidth,
        height: media.originalHeight,
        isPaused: isPaused,
        handleClose: handleClose,
        render: function render(width, height, hover) {
            var tmp = {
                mediaId: media.id,
                index: 0,
                total: 1,
                autoplay: true,
                setProgressRef: setProgressRef,
                position: "right",
                size: "sm"
            };
            if (progressSpeed !== undefined) tmp.progressSpeed = progressSpeed;
            var match = media.kind;
            var match$1 = media.kind;
            var tmp$1;
            var exit = 0;
            if (match$1 === "video" && (hover || isPaused)) exit = 1;
            else tmp$1 = null;
            if (exit === 1) tmp$1 = /*#__PURE__*/ $g85JO.createElement($jBcRb.make, {
                className: $ezf3v.prefix("absolute top-6 right-5 text-white z-20"),
                onClick: function onClick(param) {
                    $iv6Yc._1(setIsPaused, function(value) {
                        return !value;
                    });
                },
                children: isPaused ? /*#__PURE__*/ $g85JO.createElement($7wIsS.UilPlay.make, {
                    size: /* Px */ {
                        _0: 18
                    }
                }) : /*#__PURE__*/ $g85JO.createElement($7wIsS.UilPause.make, {
                    size: /* Px */ {
                        _0: 18
                    }
                }),
                block: false,
                flex: true
            });
            return /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("shadow-xl bg-black")
            }, $1lWE3.renderMedia(config.media, media, curIndex, curIndex, isPaused, false, false, $2whNH.getWithDefault(time, 0), handleTimeChange, true, muted, false, goToSlide, noop, noop, noop, noop, noopReact, undefined), /*#__PURE__*/ $g85JO.createElement($gpCTg.make, tmp), muted && setMuted !== undefined && match === "video" ? /*#__PURE__*/ $g85JO.createElement($jBcRb.make, {
                className: $ezf3v.prefix("absolute top-3 left-3 p-2 text-white z-20 bg-gray-700 rounded-full"),
                onClick: function onClick(param) {
                    $iv6Yc._1(setMuted, false);
                },
                children: /*#__PURE__*/ $g85JO.createElement($7wIsS.UilVolumeMute.make, {
                    size: /* Px */ {
                        _0: 18
                    }
                }),
                block: false,
                flex: true
            }) : null, tmp$1);
        }
    };
    if (zIndex !== undefined) tmp.zIndex = $loT9g.valFromOption(zIndex);
    return /*#__PURE__*/ $g85JO.createElement($ee69362773356d56$var$PictureInPicture2$PiP, tmp);
}
$ee69362773356d56$var$PictureInPicture2$MediaPiP.displayName = "PictureInPicture2.MediaPiP";
var $ee69362773356d56$var$make = /*#__PURE__*/ $g85JO.memo($ee69362773356d56$var$PictureInPicture2$MediaPiP);
var $ee69362773356d56$export$3dd460700b3588aa = {
    make: $ee69362773356d56$var$make
};
function $ee69362773356d56$var$PictureInPicture2$ProductsPiP(Props) {
    var products = Props.products;
    var zIndex = Props.zIndex;
    var settings = Props.settings;
    var account = Props.account;
    var onClick = Props.onClick;
    var title = Props.title;
    var firstImage = Props.firstImage;
    var firstVideo = Props.firstVideo;
    var size = $2whNH.mapWithDefault(account, "sm", function(account) {
        return account.pdpStackSize;
    });
    var position = $2whNH.mapWithDefault(account, "left", function(account) {
        return account.pdpStackPosition;
    });
    var offsetLeft = $2whNH.map(account, function(account) {
        return account.pdpStackOffset.left;
    });
    var offsetRight = $2whNH.map(account, function(account) {
        return account.pdpStackOffset.right;
    });
    var offsetBottom = $2whNH.map(account, function(account) {
        return account.pdpStackOffset.bottom;
    });
    var match = $aSJcu.use(undefined);
    var isMobile = match.isMobile;
    var match$1 = size === "sm" ? isMobile ? [
        70,
        70,
        70
    ] : [
        100,
        100,
        100
    ] : isMobile ? [
        100,
        100,
        100
    ] : [
        150,
        150,
        150
    ];
    var getItems = function getItems(width, height) {
        var products$1 = $i7mYY.keepMap($i7mYY.reverse(products), function(product) {
            var image = $i7mYY.get($7KlbQ.getValidProductImages(product), 0);
            return $2whNH.map(image, function(image) {
                return [
                    image,
                    undefined
                ];
            });
        });
        var products$2 = firstImage !== undefined ? $i7mYY.concat(products$1, [
            [
                firstImage,
                firstVideo
            ]
        ]) : firstVideo !== undefined ? $i7mYY.concat(products$1, [
            [
                firstImage,
                firstVideo
            ]
        ]) : products$1;
        var products$3 = $i7mYY.slice(products$2, -3, 3);
        return $i7mYY.mapWithIndex(products$3, function(index, param) {
            var video = param[1];
            var image = param[0];
            return [
                $2whNH.getWithDefault($2whNH.mapWithDefault(image, video, function(image) {
                    return image;
                }), String(index)),
                function(param) {
                    var tmp;
                    if (video !== undefined) {
                        var tmp$1 = {
                            src: video,
                            autoplay: settings.videoAutoPlay,
                            loop: settings.videoLoop,
                            muted: settings.videoMute,
                            controls: settings.videoControls
                        };
                        if (image !== undefined) tmp$1.poster = image;
                        tmp = /*#__PURE__*/ $g85JO.createElement("div", {
                            className: $ezf3v.prefix("absolute max-w-full max-h-full m-2 inset-0")
                        }, /*#__PURE__*/ $g85JO.createElement($1t9ha.make, tmp$1));
                    } else tmp = image !== undefined ? /*#__PURE__*/ $g85JO.createElement($55MCT.Sized.make, {
                        src: image,
                        containerWidth: width - 12 | 0,
                        containerHeight: height - 12 | 0,
                        fit: /* Cover */ 1,
                        priority: 0
                    }) : null;
                    return /*#__PURE__*/ $g85JO.createElement("div", {
                        className: $ezf3v.prefix("bg-white p-2 relative"),
                        style: {
                            height: String(height) + "px",
                            width: String(width) + "px"
                        }
                    }, tmp, title !== undefined && index === (products$3.length - 1 | 0) ? /*#__PURE__*/ $g85JO.createElement("div", {
                        className: $ezf3v.prefix("absolute w-full h-full inset-0 p-2 flex items-center justify-center text-white text-center")
                    }, /*#__PURE__*/ $g85JO.createElement("div", {
                        className: $ezf3v.prefix("absolute max-w-full max-h-full m-2 inset-0 bg-black bg-opacity-30")
                    }), /*#__PURE__*/ $g85JO.createElement("div", {
                        className: $ezf3v.prefix($1TRFX.make([
                            "max-w-full filter drop-shadow font-bold tracking-widest leading-normal uppercase break-words",
                            size === "sm" && isMobile ? "text-xs" : ""
                        ]))
                    }, title)) : null);
                },
                onClick
            ];
        });
    };
    if (products.length === 0) return null;
    var tmp = {
        mediaId: "product",
        width: match$1[0],
        height: match$1[1],
        interactive: false,
        handleClose: function handleClose(param) {},
        render: function render(width, height, hover) {
            var width$1 = width | 0;
            var height$1 = height | 0;
            var tmp = {
                maxThumbnails: 3,
                items: getItems(width$1, height$1),
                direction: /* Fan */ 2,
                width: width$1,
                height: height$1,
                rotation: position === "right" ? /* Positive */ 1 : /* Negative */ 0
            };
            if (offsetLeft !== undefined) tmp.offsetLeft = $loT9g.valFromOption(offsetLeft);
            if (offsetRight !== undefined) tmp.offsetRight = $loT9g.valFromOption(offsetRight);
            if (offsetBottom !== undefined) tmp.offsetBottom = $loT9g.valFromOption(offsetBottom);
            return /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("-mt-8")
            }, /*#__PURE__*/ $g85JO.createElement($b5sXm.make, tmp));
        },
        renderHover: function renderHover(param) {
            return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined);
        },
        renderOverlay: function renderOverlay(param) {
            return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined);
        },
        maxSize: match$1[2],
        position: position
    };
    if (zIndex !== undefined) tmp.zIndex = $loT9g.valFromOption(zIndex);
    return /*#__PURE__*/ $g85JO.createElement($ee69362773356d56$var$PictureInPicture2$PiP, tmp);
}
$ee69362773356d56$var$PictureInPicture2$ProductsPiP.displayName = "PictureInPicture2.ProductsPiP";
var $ee69362773356d56$export$e150d92970e5308f = {
    make: $ee69362773356d56$var$PictureInPicture2$ProductsPiP
};
function $ee69362773356d56$var$PictureInPicture2$ProductPiP(Props) {
    var storeId = Props.storeId;
    var smartnavApiHost = Props.smartnavApiHost;
    var productId = Props.productId;
    var zIndex = Props.zIndex;
    var settings = Props.settings;
    var account = Props.account;
    var match = $9pMGg.use(undefined);
    var match$1 = $c6E1z.useRelatedProducts(productId, storeId, "", true, true, smartnavApiHost, match.market, undefined);
    var products = $2whNH.getWithDefault(match$1.products, []);
    var match$2 = $hBcYV.useRouter(undefined);
    var goTo = match$2.goTo;
    var onClick = function onClick(param) {
        $iv6Yc._3(goTo, undefined, undefined, {
            TAG: /* ListPage */ 1,
            _0: {
                listPageType: {
                    TAG: /* Product */ 1,
                    _0: productId
                },
                viewPLP: true,
                filters: undefined,
                sort: undefined
            }
        });
    };
    var match$3 = $aSJcu.use(undefined);
    var tmp = {
        products: products,
        settings: settings,
        onClick: onClick,
        title: match$3.isMobile ? "Related" : "Related Products"
    };
    if (zIndex !== undefined) tmp.zIndex = $loT9g.valFromOption(zIndex);
    if (account !== undefined) tmp.account = $loT9g.valFromOption(account);
    return /*#__PURE__*/ $g85JO.createElement($ee69362773356d56$var$PictureInPicture2$ProductsPiP, tmp);
}
$ee69362773356d56$var$PictureInPicture2$ProductPiP.displayName = "PictureInPicture2.ProductPiP";
var $ee69362773356d56$export$3da1fcaa27fa485e = {
    make: $ee69362773356d56$var$PictureInPicture2$ProductPiP
};
function $ee69362773356d56$var$PictureInPicture2$CategoryPiP(Props) {
    var storeId = Props.storeId;
    var category = Props.category;
    var categoryId = Props.categoryId;
    var productId = Props.productId;
    var zIndex = Props.zIndex;
    var settings = Props.settings;
    var account = Props.account;
    var smartnavApiHost = Props.smartnavApiHost;
    var featuredProductsIds = $1xf0g.getProductIds(category);
    var shouldFetchFeaturedProducts = featuredProductsIds.length !== 0;
    var match = $9pMGg.use(undefined);
    var market = match.market;
    var match$1 = $c6E1z.useProductsById(storeId, featuredProductsIds, true, shouldFetchFeaturedProducts, categoryId, smartnavApiHost, market, undefined);
    var defaultFilters = $2whNH.flatMap($1xf0g.ExternalConnection.getStoreCategoryConnection(category), function(connection) {
        return $1xf0g.ExternalConnection.getFilterBy(connection, account);
    });
    var match$2 = $c6E1z.useCategoryProducts(storeId, categoryId, $1xf0g.ExternalConnection.getStoreCategoryConnection(category), true, undefined, defaultFilters, 4, undefined, featuredProductsIds.length < 3, smartnavApiHost, market, undefined);
    var products = $2whNH.getWithDefault(match$2.products, []);
    var featuredProducts = $2whNH.getWithDefault(match$1.products, []);
    var products$1 = $i7mYY.keep($i7mYY.concat(featuredProducts, products), function(p) {
        return p.id !== productId;
    });
    $8E2YL.use(undefined).config;
    var match$3 = $hBcYV.useRouter(undefined);
    var goTo = match$3.goTo;
    var onClick = function onClick(param) {
        $iv6Yc._3(goTo, undefined, undefined, {
            TAG: /* ListPage */ 1,
            _0: {
                listPageType: {
                    TAG: /* Category */ 0,
                    _0: categoryId
                },
                viewPLP: true,
                filters: undefined,
                sort: undefined
            }
        });
    };
    var match$4 = category.card;
    var firstImage;
    var exit = 0;
    var imageUrl;
    switch(match$4.TAG | 0){
        case /* ImageLinkCard */ 0:
            imageUrl = match$4._0.imageUrl;
            exit = 1;
            break;
        case /* VideoLinkCard */ 1:
            firstImage = match$4._0.fallbackImageUrl;
            break;
        case /* ImageCard */ 2:
            imageUrl = match$4._0.imageUrl;
            exit = 1;
            break;
        case /* VideoCard */ 3:
            firstImage = match$4._0.fallbackImageUrl;
            break;
        case /* MedialessCard */ 4:
        case /* MedialessLinkCard */ 5:
            firstImage = undefined;
            break;
        case /* ImageDisplayCard */ 6:
            imageUrl = match$4._0.imageUrl;
            exit = 1;
            break;
        case /* VideoDisplayCard */ 7:
            firstImage = match$4._0.fallbackImageUrl;
            break;
    }
    if (exit === 1) firstImage = imageUrl !== "" ? imageUrl : undefined;
    var match$5 = category.card;
    var firstVideo;
    var exit$1 = 0;
    var videoUrl;
    switch(match$5.TAG | 0){
        case /* VideoLinkCard */ 1:
            videoUrl = match$5._0.videoUrl;
            exit$1 = 1;
            break;
        case /* VideoCard */ 3:
            videoUrl = match$5._0.videoUrl;
            exit$1 = 1;
            break;
        case /* VideoDisplayCard */ 7:
            videoUrl = match$5._0.videoUrl;
            exit$1 = 1;
            break;
        default:
            firstVideo = undefined;
    }
    if (exit$1 === 1) firstVideo = videoUrl !== "" ? videoUrl : undefined;
    var tmp = {
        products: products$1,
        settings: settings,
        onClick: onClick,
        title: category.title
    };
    if (zIndex !== undefined) tmp.zIndex = $loT9g.valFromOption(zIndex);
    if (account !== undefined) tmp.account = $loT9g.valFromOption(account);
    if (firstImage !== undefined) tmp.firstImage = $loT9g.valFromOption(firstImage);
    if (firstVideo !== undefined) tmp.firstVideo = $loT9g.valFromOption(firstVideo);
    return /*#__PURE__*/ $g85JO.createElement($ee69362773356d56$var$PictureInPicture2$ProductsPiP, tmp);
}
$ee69362773356d56$var$PictureInPicture2$CategoryPiP.displayName = "PictureInPicture2.CategoryPiP";
var $ee69362773356d56$export$21a5ad6fe88e8a2f = {
    make: $ee69362773356d56$var$PictureInPicture2$CategoryPiP
};
function $ee69362773356d56$var$PictureInPicture2(Props) {
    var match = $9pMGg.use(undefined);
    var smartnavApiHost = match.smartnavApiHost;
    var match$1 = $gtaS4.use(undefined);
    var match$2 = $8E2YL.use(undefined).config;
    var account = match$2.transitiveAccount;
    var storeId = match$2.transitiveStoreId;
    var settings = match$2.settings;
    var categories = match$2.categories;
    var match$3 = $hBcYV.useRouter(undefined);
    var zIndex = settings.zIndexInt;
    var isSmartBarEnabled = $gS5nW.isSmartBarEnabled(match.embedType) || match$3.route !== /* NotRendered */ 0;
    var productId = $cdK26.getProductPageProductId(undefined);
    if (match$1.mediaId !== undefined) return /*#__PURE__*/ $g85JO.createElement($ee69362773356d56$var$make, {
        zIndex: zIndex
    });
    if (productId === undefined) return null;
    var pdpStackEnabled = $2whNH.mapWithDefault(account, false, function(account) {
        return account.pdpStackEnabled;
    });
    var categoryId = $hm3Un.getFromSessionStorage("category");
    var category = $2whNH.flatMap(categoryId, function(categoryId) {
        return $1xf0g.getCategoryById(categories, categoryId);
    });
    var enabled = pdpStackEnabled && !isSmartBarEnabled ? true : false;
    if (!enabled) return null;
    if (categoryId !== undefined && category !== undefined) {
        var tmp = {
            storeId: storeId,
            category: category,
            categoryId: categoryId,
            productId: productId,
            zIndex: zIndex,
            settings: settings,
            smartnavApiHost: smartnavApiHost
        };
        if (account !== undefined) tmp.account = $loT9g.valFromOption(account);
        return /*#__PURE__*/ $g85JO.createElement($ee69362773356d56$var$PictureInPicture2$CategoryPiP, tmp);
    }
    var tmp$1 = {
        storeId: storeId,
        smartnavApiHost: smartnavApiHost,
        productId: productId,
        zIndex: zIndex,
        settings: settings
    };
    if (account !== undefined) tmp$1.account = $loT9g.valFromOption(account);
    return /*#__PURE__*/ $g85JO.createElement($ee69362773356d56$var$PictureInPicture2$ProductPiP, tmp$1);
}
$ee69362773356d56$var$PictureInPicture2.displayName = "PictureInPicture2";
var $ee69362773356d56$export$dd44f18ab656f3bb = $ee69362773356d56$var$PictureInPicture2;
var $ee69362773356d56$export$aa541d093b11ace2 = $ee69362773356d56$var$PictureInPicture2;
 /* make Not a pure module */ 
});
parcelRegister("b5sXm", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $81269f7e71e1c8d1$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $ezf3v = parcelRequire("ezf3v");

var $jBcRb = parcelRequire("jBcRb");
function $81269f7e71e1c8d1$var$Stack(Props) {
    var maxThumbnails = Props.maxThumbnails;
    var items = Props.items;
    var isVisibleOpt = Props.isVisible;
    var directionOpt = Props.direction;
    var spacingOpt = Props.spacing;
    var widthOpt = Props.width;
    var offsetLeftOpt = Props.offsetLeft;
    var offsetRightOpt = Props.offsetRight;
    var offsetBottomOpt = Props.offsetBottom;
    var heightOpt = Props.height;
    var rotationOpt = Props.rotation;
    var isVisible = isVisibleOpt !== undefined ? isVisibleOpt : true;
    var direction = directionOpt !== undefined ? directionOpt : /* Vertical */ 0;
    var spacing = spacingOpt !== undefined ? spacingOpt : 8;
    var width = widthOpt !== undefined ? widthOpt : 0;
    var offsetLeft = offsetLeftOpt !== undefined ? offsetLeftOpt : 0;
    var offsetRight = offsetRightOpt !== undefined ? offsetRightOpt : 0;
    var offsetBottom = offsetBottomOpt !== undefined ? offsetBottomOpt : 0;
    var height = heightOpt !== undefined ? heightOpt : 0;
    var rotation = rotationOpt !== undefined ? rotationOpt : /* Positive */ 1;
    var match = $g85JO.useState(function() {
        return false;
    });
    var setThumbnailsMouseOver = match[1];
    var thumbnailsMouseOver = match[0];
    var total = items.length;
    var thumbnails = $i7mYY.mapWithIndex(items, function(index, param) {
        var id = param[0];
        var render = param[1];
        var onClick = param[2];
        var tilt = index - (total - (4 < maxThumbnails ? 4 : maxThumbnails) | 0) | 0;
        var x;
        if (thumbnailsMouseOver) switch(direction){
            case /* Vertical */ 0:
                x = 0;
                break;
            case /* Horizontal */ 1:
                x = Math.imul(index, width + spacing | 0);
                break;
            case /* Fan */ 2:
                x = (tilt > 0 ? tilt : 0) << 1;
                break;
        }
        else x = (tilt > 0 ? tilt : 0) << 1;
        var x$1 = String(x + spacing | 0);
        var y;
        if (thumbnailsMouseOver) switch(direction){
            case /* Vertical */ 0:
                y = Math.imul(index, height + spacing | 0);
                break;
            case /* Horizontal */ 1:
                y = 0;
                break;
            case /* Fan */ 2:
                y = Math.imul(tilt > 0 ? tilt : 0, 3);
                break;
        }
        else y = Math.imul(tilt > 0 ? tilt : 0, 3);
        var y$1 = String(y + spacing | 0);
        var angle = thumbnailsMouseOver ? direction >= 2 ? Math.imul(tilt > 0 ? tilt : 0, 7) : 0 : Math.imul(tilt > 0 ? tilt : 0, 5);
        var angle$1 = String(rotation ? angle : -angle | 0);
        var className = $ezf3v.prefix($1TRFX.make([
            "relative transition-shadow duration-500 bg-white",
            thumbnailsMouseOver || tilt >= 0 ? "shadow" : ""
        ]));
        return /*#__PURE__*/ $g85JO.createElement("div", {
            key: id,
            className: $ezf3v.prefix("absolute transition-transform duration-200 pointer-events-auto"),
            style: {
                transform: "translate(" + x$1 + "px, " + y$1 + "px) rotate(" + angle$1 + "deg)"
            }
        }, /*#__PURE__*/ $g85JO.createElement($jBcRb.make, {
            onClick: function onClick1(e) {
                e.stopPropagation();
                e.preventDefault();
                $iv6Yc._1(onClick, undefined);
            },
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                className: className
            }, $iv6Yc._1(render, undefined))
        }));
    });
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("relative"),
        style: {
            left: $ezf3v.intToPx(offsetLeft)
        }
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("relative"),
        style: {
            right: $ezf3v.intToPx(offsetRight)
        }
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("relative"),
        style: {
            bottom: $ezf3v.intToPx(offsetBottom)
        }
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "transition-opacity duration-200",
            isVisible ? "opacity-100" : "opacity-0"
        ])),
        onMouseEnter: function onMouseEnter(param) {
            $iv6Yc._1(setThumbnailsMouseOver, function(param) {
                return true;
            });
        },
        onMouseLeave: function onMouseLeave(param) {
            $iv6Yc._1(setThumbnailsMouseOver, function(param) {
                return false;
            });
        }
    }, thumbnails))));
}
$81269f7e71e1c8d1$var$Stack.displayName = "Stack";
var $81269f7e71e1c8d1$export$dd44f18ab656f3bb = $81269f7e71e1c8d1$var$Stack;
 /* react Not a pure module */ 
});

parcelRegister("gS5nW", function(module, exports) {

$parcel$export(module.exports, "isSmartBarEnabled", function () { return $c485ddd776de0bab$export$ccbe0f993fadc043; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $cdK26 = parcelRequire("cdK26");
var $c485ddd776de0bab$export$e678e550fcfcad5f = /^\/cart|^\/store\/jump\/static|^\/orderconfirmation|^\/pages\/mattressquiz|^\/collections\/limited-edition/i;
function $c485ddd776de0bab$export$ccbe0f993fadc043(embedType) {
    var isShopifyProductPage = $cdK26.isProductPage(undefined);
    var isBlacklisted = $2whNH.isSome($loT9g.null_to_opt(window.location.pathname.match($c485ddd776de0bab$export$e678e550fcfcad5f)));
    if (embedType !== 0) return true;
    else if (isShopifyProductPage) return false;
    else return !isBlacklisted;
}
 /* No side effect */ 
});

parcelRegister("gSQ4v", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $c4aa14da03a23dfe$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");
function $c4aa14da03a23dfe$var$IconPIPExpand(Props) {
    var className = Props.className;
    var tmp = {
        height: "20",
        width: "22",
        fill: "none",
        viewBox: "0 0 22 20",
        xmlns: "http://www.w3.org/2000/svg"
    };
    if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement("svg", tmp, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M9.125 9.4375C10.2296 9.4375 11.125 8.5421 11.125 7.4375V2.4375C11.125 1.33293 10.2296 0.4375 9.125 0.4375H2.125C1.02043 0.4375 0.125 1.33293 0.125 2.4375V7.4375C0.125 8.19689 0.54823 8.8574 1.17168 9.1961C1.45507 9.3501 1.77982 9.4375 2.125 9.4375H9.125ZM9.125 10.4375H2.125C1.77436 10.4375 1.43778 10.3773 1.125 10.2668V16.1875C1.125 17.9824 1.125 19.4375 1.125 19.4375H17.875C19.6699 19.4375 21.125 19.4375 21.125 19.4375V3.4375C21.125 3.4375 19.6699 3.4375 17.875 3.4375H12.125V7.4375C12.125 9.0944 10.7819 10.4375 9.125 10.4375ZM13.375 14.4375H15.0643L12.3447 11.7178C12.0518 11.4249 12.0518 10.9501 12.3447 10.6572C12.6376 10.3643 13.1124 10.3643 13.4053 10.6572L16.125 13.3768V11.6875C16.125 11.2733 16.4608 10.9375 16.875 10.9375C17.2892 10.9375 17.625 11.2733 17.625 11.6875V15.1875C17.625 15.6017 17.2892 15.9375 16.875 15.9375H13.375C12.9608 15.9375 12.625 15.6017 12.625 15.1875C12.625 14.7733 12.9608 14.4375 13.375 14.4375Z",
        fill: "currentColor"
    }));
}
$c4aa14da03a23dfe$var$IconPIPExpand.displayName = "IconPIPExpand";
var $c4aa14da03a23dfe$export$dd44f18ab656f3bb = $c4aa14da03a23dfe$var$IconPIPExpand;
 /* react Not a pure module */ 
});


})();
//# sourceMappingURL=PictureInPicture2.bs.e0c9bd93.js.map
